import Dialog from '@material-ui/core/Dialog'
import PropTypes from 'prop-types'

function ConfirmationDialogRaw(props: {
  [x: string]: any
  open: any
}): JSX.Element {
  const { onClose, valueProp, open, maxWidth, ...other } = props

  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth={maxWidth}
      aria-labelledby='confirmation-dialog-title'
      open={open}
      {...other}
    ></Dialog>
  )
}

ConfirmationDialogRaw.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
}

export default ConfirmationDialogRaw
